export default "__VITE_ASSET__BJN2iQuL__"